export default __webpack_public_path__ + "static/2.3-4037b9278e8c67efa3ac52c12cda5dae.webp";